import { Calendar, Coffee, Phone } from "lucide-react";

const CAL_URL = "https://calendar.app.google/2K9EBUh8taRBcRi89";

export default function BookDemoBlock() {
    return (
        <section className="py-20 md:py-24 bg-white border-t border-slate-200/70" data-testid="book-demo-block">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="rounded-3xl bg-gradient-to-br from-slate-50 to-sky-50/60 border border-slate-200 p-8 md:p-12 grid lg:grid-cols-12 gap-8 items-center relative overflow-hidden">
                    <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-sky-200/40 blur-3xl" />
                    <div className="relative lg:col-span-7">
                        <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                            <Coffee className="h-3 w-3 text-sky-600" />
                            En uforpligtende snak
                        </div>
                        <h2 className="mt-4 font-display text-2xl md:text-4xl font-bold tracking-tight text-slate-900">
                            Tag 20 minutter med stifteren.
                        </h2>
                        <p className="mt-3 text-base text-slate-600 leading-relaxed max-w-xl">
                            Vi viser dig Cleany live, hører om jeres drift, og finder ud af om
                            det giver mening for jer at være med fra dag ét. Ingen salgstale —
                            bare en god snak.
                        </p>
                        <div className="mt-6 flex flex-col sm:flex-row gap-3">
                            <a
                                href={CAL_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="book-demo-cta"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold px-6 h-12 transition-all active:scale-[0.97] shadow-lg"
                            >
                                <Calendar className="h-4 w-4" />
                                Book 20 min. demo
                            </a>
                            <a
                                href="tel:+4570221990"
                                className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white hover:border-slate-400 text-slate-800 font-medium px-6 h-12 transition-colors"
                                data-testid="book-demo-call"
                            >
                                <Phone className="h-4 w-4" />
                                Eller ring +45 70 22 19 90
                            </a>
                        </div>
                    </div>
                    <div className="relative lg:col-span-5">
                        <div className="rounded-2xl bg-white border border-slate-200 p-6 shadow-xl shadow-sky-900/5">
                            <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-4">Hvad får du ud af mødet?</div>
                            <ul className="space-y-3 text-sm text-slate-700">
                                {[
                                    "Live demo af de moduler der er relevante for jer",
                                    "Estimeret tids- og prisbesparelse for jeres firma",
                                    "Spørg ind til alt — vi har ingen sælger-script",
                                    "Beslut bagefter — vi kontakter aldrig uopfordret",
                                ].map((p) => (
                                    <li key={p} className="flex items-start gap-2.5">
                                        <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-sky-500 shrink-0" />
                                        {p}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
